import { useReducer } from 'react';
import type * as api from '../../../api';
import { type KYCFieldDefinition } from './KYCFieldDefinitions';

type State = Array<KYCFieldDefinition & { isSelected: boolean; isRequired: boolean; purpose: api.KycFieldPurpose[] }>;

type Action =
    | { type: 'selectFields'; keys: api.LocalCustomerFieldKey[] }
    | { type: 'setRequired'; key: api.LocalCustomerFieldKey; value: boolean }
    | { type: 'setPurpose'; key: api.LocalCustomerFieldKey; value: api.KycFieldPurpose[] };

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'selectFields':
            return state.map(item => ({ ...item, isSelected: action.keys.includes(item.key) }));

        case 'setRequired':
            return state.map(item => {
                if (item.key === action.key) {
                    return { ...item, isRequired: action.value };
                }

                return item;
            });

        case 'setPurpose':
            return state.map(item => {
                if (item.key === action.key) {
                    return { ...item, purpose: action.value };
                }

                return item;
            });

        default:
            return state;
    }
};

const useListReducer = state => useReducer(reducer, state);

export default useListReducer;
